// Module
var code = "<div class=\"modal fade\" id=\"uploadCsvMetaDataModal\"> <wt-modal modal-title=\"{{'Update tags meta-data'|translate}}\" modal-caption-yes=\"Import\" modal-caption-no=\"Cancel\" yes-function=\"vm.upload(vm.fileList)\" yes-disabled=\"!vm.fileList && !vm.fileList.length\"> <wt-tags-import></wt-tags-import> </wt-modal> </div>";
// Exports
module.exports = code;